import React from 'react';

export const BuildingIcon = (props) => {

  const {isSupervisor, isConnected, isSelected, theme} = props;

  const determineStatus = (isConnected, theme) => {
    if (isSelected) {
      return '#46B3BA'
    }
    if (!isSupervisor && !isConnected) {
      return theme === 'light' ? '#B9C1C8' : '#5a5555';
    }
    return theme === 'light' ? '#3E586B' : '#B9C1C8';

  }

  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 16 17" 
      version="1.1" 
      xmlns="http://www.w3.org/2000/svg" 
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinejoin: "round",
        strokeMiterlimit: 2,
      }}
    >
      <defs>
        <style>
          {`

            .blink {
              animation: line-blink 1s ease-in infinite;
            }
            
            @keyframes line-blink {
              from {
                opacity: 1;
              }
              to {
                opacity: 0;
              }
            }
          `}
        </style>
      </defs>
      <path d="M15.782,17L0.218,17C0.098,17 0,16.889 0,16.753L0,15.248C0,15.111 0.098,15 0.218,15L15.782,15C15.902,15 16,15.111 16,15.248L16,16.753C16,16.889 15.902,17 15.782,17Z" style={{fill: determineStatus(isConnected, theme) }} />
      <path d="M13.468,16L2.532,16C2.238,16 2,15.781 2,15.512L2,0.488C2,0.218 2.238,0 2.532,0L13.468,0C13.762,0 14,0.218 14,0.488L14,15.512C14,15.781 13.762,16 13.468,16ZM10.871,13.723L8.852,13.723C8.837,13.723 8.825,13.71 8.825,13.695L8.825,11.677C8.825,11.661 8.837,11.649 8.852,11.649L10.871,11.649C10.886,11.649 10.898,11.661 10.898,11.677L10.898,13.695C10.898,13.71 10.886,13.723 10.871,13.723ZM7.069,13.723L5.051,13.723C5.035,13.723 5.023,13.71 5.023,13.695L5.023,11.677C5.023,11.661 5.035,11.649 5.051,11.649L7.069,11.649C7.084,11.649 7.097,11.661 7.097,11.677L7.097,13.695C7.097,13.71 7.084,13.723 7.069,13.723ZM10.871,9.288L8.852,9.288C8.837,9.288 8.825,9.275 8.825,9.26L8.825,7.241C8.825,7.226 8.837,7.214 8.852,7.214L10.871,7.214C10.886,7.214 10.898,7.226 10.898,7.241L10.898,9.26C10.898,9.275 10.886,9.288 10.871,9.288ZM7.069,9.288L5.051,9.288C5.035,9.288 5.023,9.275 5.023,9.26L5.023,7.241C5.023,7.226 5.035,7.214 5.051,7.214L7.069,7.214C7.084,7.214 7.097,7.226 7.097,7.241L7.097,9.26C7.097,9.275 7.084,9.288 7.069,9.288ZM7.069,5.011L5.051,5.011C5.035,5.011 5.023,4.998 5.023,4.983L5.023,2.965C5.023,2.949 5.035,2.937 5.051,2.937L7.069,2.937C7.084,2.937 7.097,2.949 7.097,2.965L7.097,4.983C7.097,4.998 7.084,5.011 7.069,5.011ZM10.871,5.011L8.852,5.011C8.837,5.011 8.825,4.998 8.825,4.983L8.825,2.965C8.825,2.949 8.837,2.937 8.852,2.937L10.871,2.937C10.886,2.937 10.898,2.949 10.898,2.965L10.898,4.983C10.898,4.998 10.886,5.011 10.871,5.011Z" style={{fill: determineStatus(isConnected, theme) }} />
      {
        !isSupervisor && !isConnected ?
          <g transform="matrix(1,0,0,1,0,-7.5808)">
            <g transform="matrix(0.0173529,0,0,0.0173529,0.977847,7.44114)">
              <path d="M475.333,556C493.5,573.408 503.784,597.506 503.784,622.667C503.784,647.827 493.5,671.926 475.333,689.333C435.81,726.379 373.523,726.379 334,689.333C315.834,671.926 305.549,647.827 305.549,622.667C305.549,597.506 315.834,573.408 334,556C373.523,518.954 435.81,518.954 475.333,556Z" fill="#eb695a" fillRule="nonzero" className="blink" />
              <path d="M506.598,523.373C506.478,523.258 506.358,523.144 506.237,523.03C449.43,469.784 359.903,469.784 303.097,523.03C302.976,523.144 302.855,523.258 302.735,523.373C275.678,549.3 260.361,585.192 260.361,622.667C260.361,660.141 275.678,696.033 302.735,721.961C302.855,722.075 302.976,722.19 303.097,722.303C359.903,775.549 449.43,775.549 506.237,722.303C506.358,722.19 506.478,722.075 506.598,721.961C533.655,696.033 548.973,660.141 548.973,622.667C548.973,585.192 533.655,549.3 506.598,523.373ZM475.333,556C493.5,573.408 503.784,597.506 503.784,622.667C503.784,647.827 493.5,671.926 475.333,689.333C435.81,726.379 373.523,726.379 334,689.333C315.834,671.926 305.549,647.827 305.549,622.667C305.549,597.506 315.834,573.408 334,556C373.523,518.954 435.81,518.954 475.333,556Z" fill="#EBEBEB" className="blink" />
            </g>
            <g transform="matrix(0.0173529,0,0,0.0173529,0.818779,7.44114)">
              <path d="M235.333,537.667L143.333,441.333C294.782,299.908 532.885,299.908 684.333,441.333L592.333,537.667C492.435,444.245 335.231,444.245 235.333,537.667Z" fill="#eb695a" fillRule="nonzero" className="blink" />
              <path d="M202.653,568.877C219.763,586.791 248.106,587.592 266.199,570.672C348.823,493.404 478.844,493.404 561.468,570.672C579.561,587.592 607.904,586.791 625.013,568.877L717.013,472.543C725.351,463.812 729.849,452.108 729.504,440.041C729.158,427.973 723.999,416.545 715.175,408.306C546.458,250.756 281.208,250.756 112.492,408.306C103.668,416.545 98.508,427.973 98.163,440.041C97.818,452.108 102.315,463.812 110.653,472.543L202.653,568.877ZM235.333,537.667L143.333,441.333C294.782,299.908 532.885,299.908 684.333,441.333L592.333,537.667C492.435,444.245 335.231,444.245 235.333,537.667Z" fill="#EBEBEB" className="blink" />
            </g>
            <g transform="matrix(0.0173529,0,0,0.0173529,0.818779,7.44114)">
              <path d="M720.667,382C548.923,221.466 278.743,221.466 107,382L15,285.333C238.294,76.796 589.373,76.796 812.667,285.333L720.667,382Z" fill="#eb695a" fillRule="nonzero" className="blink" />
              <path d="M689.809,415.013C707.925,431.947 736.304,431.117 753.4,413.153L845.4,316.487C853.714,307.752 858.191,296.056 857.836,284.003C857.481,271.95 852.323,260.538 843.51,252.307C602.948,27.643 224.719,27.643 -15.843,252.307C-24.656,260.538 -29.814,271.95 -30.169,284.003C-30.524,296.056 -26.047,307.752 -17.734,316.487L74.266,413.153C91.363,431.117 119.741,431.947 137.858,415.013C292.329,270.623 535.338,270.623 689.809,415.013ZM720.667,382C548.923,221.466 278.743,221.466 107,382L15,285.333C238.294,76.796 589.373,76.796 812.667,285.333L720.667,382Z" fill="#EBEBEB" className="blink" />
            </g>
          </g>
        :
        null
      }
    </svg>
    )
};


